import { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import ListIcon from "../../assets/ListIcon";
import MoneyBagIcon from "../../assets/MoneyBagIcon";
import PersonIcon from "../../assets/PersonIcon";
import SettingsIcon from "../../assets/SettingsIcon";
import ComputerImage from "../../assets/computerImage.png";
import HeadingMain from "../../components/Heading";
import './index.scss'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const HowWorks = () => {
    const [index, setIndex] = useState(1)

    const renderText = () => {
        switch (index) {
            case 1:
                return 'Secure sharing of your data to empower you'
            case 2:
                return 'Verify your credit limit and interest rate'
            case 3:
                return 'Digital KYC verification, Auto-repayment set up, E-Sign'
            case 4:
                return 'We pay on your behalf, you repay in 1 month'
            default:
                break;
        }
    }

    return (
        <section className="mainContent">
            <Col md={12} className="headingSection">
                <HeadingMain text="How it works" />
            </Col>
            <Row>
                <Col md={12} lg={5}>
                    <div className="sectionTabs">
                        <div className="iconTextContainer">
                          <ul>
                            <li>
                              <SettingsIcon />
                              <div className="content">
                                <h4>Check Eligibility</h4>
                                <p>Secure sharing of your data to empower you</p>
                              </div>
                              <ArrowDownwardIcon className="arrowicon" />
                            </li>
                            <li>
                              <ListIcon />
                              <div className="content">
                                <h4>Accept Offer</h4>
                                <p>Verify your credit limit and interest rate</p>
                              </div>
                              <ArrowDownwardIcon className="arrowicon" />
                            </li>
                            <li>
                              <PersonIcon />
                              <div className="content">
                                <h4>Onboarding</h4>
                                <p>Digital KYC verification, Auto-repayment set up, E-Sign</p>
                              </div>
                              <ArrowDownwardIcon className="arrowicon" />
                            </li>
                            <li>
                              <MoneyBagIcon />
                              <div className="content">
                                <h4>Add Challan, Get it Disbursed</h4>
                                <p>We pay on your behalf, repay in 1 month</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                    </div>
                </Col>
                <Col md={12} lg={7}>
                    <div className="computerContainer">
                        <img src={'how_it_works.gif'} />
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default HowWorks;